import styled from 'styled-components'

const ButtonContainer = styled.button`
  width: 340px;
  font-size: 2.5rem;
  padding: 5px;
  margin: 5px;
  border-radius: 5px;
  border: solid 1px var(--primary-border);
  background-color: var(--button);
`

export default ButtonContainer
